/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetHelpdeskAreasPathParameters } from 'api/actions/get-helpdesk-areas/get-helpdesk-areas-path-parameters';
import { GetHelpdeskAreasResponse } from 'api/actions/get-helpdesk-areas/get-helpdesk-areas-response';

type GetHelpdeskAreasQueryParameters = Record<string, any>;

/**
 * The path of the GetHelpdeskAreas action.
 */
export const getHelpdeskAreasActionPath = new SweetPath<keyof GetHelpdeskAreasPathParameters>('/help-desk/areas', {
  path: '{param}',
});

/**
 * Creates a contextualized GetHelpdeskAreas actions.
 */
export default function createGetHelpdeskAreasAction(axios: AxiosInstance) {
  return function getHelpdeskAreasAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetHelpdeskAreasQueryParameters } = {}) {
    const path = getHelpdeskAreasActionPath.original;

    return axios.get<GetHelpdeskAreasResponse, GetHelpdeskAreasResponse>(path, { params: query, headers });
  };
}
